import { render, staticRenderFns } from "./CheckInDossierTable.vue?vue&type=template&id=51eb131b&scoped=true"
import script from "./CheckInDossierTable.vue?vue&type=script&lang=ts"
export * from "./CheckInDossierTable.vue?vue&type=script&lang=ts"
import style0 from "./CheckInDossierTable.vue?vue&type=style&index=0&id=51eb131b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eb131b",
  null
  
)

export default component.exports